import { Spinner } from '@common/components/Spinner/Spinner';
import { fetchBasketDetails } from '@store/basket/actions';
import { basketSelectors } from '@store/basket/selectors';
import { entitySelectors } from '@store/entity';
import { FC } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { BasketDetails } from 'shared-types/Basket';
import { Property } from 'shared-types/Property';
import {
  AppliedVoucherCodesItem,
  AppliedVoucherCodesItemCode,
  AppliedVoucherCodesItemName,
  AppliedVoucherCodesItemRedemptionTotal,
  AppliedVoucherCodesItemRemoveButton,
  AppliedVoucherCodesWrapper,
} from './AppliedVoucherCodes.styles';
import { useRemoveVoucherCode } from './useRemoveVoucherCode';
import { useTranslations } from '@lang';

const mapStateToProps = (state) => ({
  basketDetails: basketSelectors.getBasketDetails(state),
  property: entitySelectors.getProperty(state),
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      fetchBasketDetails,
    },
    dispatch
  );

type AppliedVoucherCodesProps = {
  basketDetails: BasketDetails;
  property: Property;
  fetchBasketDetails: (
    propertyId: number,
    basketId: number | string,
    language: string
  ) => Promise<void>;
  allowRemove?: boolean;
};
export const AppliedVoucherCodesComponent: FC<AppliedVoucherCodesProps> = ({
  basketDetails,
  property,
  fetchBasketDetails,
  allowRemove = true,
}) => {
  const { t } = useTranslations();
  const basketVouchers = basketDetails?.vouchers;
  const refetchBasket = async () => {
    await fetchBasketDetails(property.id, basketDetails.id, property.defaultLanguage);
  };
  const { isLoading: isLoadingRemoveVoucher, mutate: removeVoucherMutate } = useRemoveVoucherCode(
    property.id,
    basketDetails.id,
    refetchBasket,
    () => {}
  );

  const removeVoucher = async (code: string) => {
    await removeVoucherMutate(code);
  };

  return (basketVouchers || []).length > 0 ? (
    <>
      <Spinner showDelayMessage isActive={isLoadingRemoveVoucher} />
      <AppliedVoucherCodesWrapper>
        {(basketVouchers || []).map((voucher) => {
          return (
            <AppliedVoucherCodesItem key={voucher.code}>
              <AppliedVoucherCodesItemCode>{voucher.code}</AppliedVoucherCodesItemCode>
              {allowRemove && (
                <AppliedVoucherCodesItemRemoveButton onClick={() => removeVoucher(voucher.code)}>
                  {t('common.remove')}
                </AppliedVoucherCodesItemRemoveButton>
              )}
              <AppliedVoucherCodesItemRedemptionTotal>
                -{voucher.redemptionTotal.prefix}
                {(voucher.redemptionTotal.amount / 100).toFixed(2)}
              </AppliedVoucherCodesItemRedemptionTotal>
              {voucher.name && (
                <AppliedVoucherCodesItemName>{voucher.name}</AppliedVoucherCodesItemName>
              )}
            </AppliedVoucherCodesItem>
          );
        })}
      </AppliedVoucherCodesWrapper>
    </>
  ) : null;
};

export const AppliedVoucherCodes: any = connect(
  mapStateToProps,
  mapDispatchToProps
)(AppliedVoucherCodesComponent as any);
